export const companyName = "Kerminue Trinity Services";
export const companyMainAddress =
  "Ajman Free Zone c1 building, Ajman, United Arab Emirates";
export const contactPhone = "+971 504211682";
export const web = "www.kerminue.com";
export const contactEmail = "info@kerminue.com";
